import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

export function ToggleChip({
  value,
  onChange,
  label,
}: {
  value: boolean;
  onChange: (next: boolean) => void;
  label: string;
}) {
  const { t } = useTranslation('intake');
  const displayLabel = t(`fieldLabels.${label}`, { defaultValue: label });

  return (
    <button
      type="button"
      onClick={() => onChange(!value)}
      className={cn(
        'rounded-full border px-3 py-1.5 text-xs transition',
        value
          ? 'border-synergy-blue bg-synergy-blue/10 text-synergy-blue'
          : 'border-synergy-neutral-700/40 bg-white/40 text-synergy-text-tertiary',
      )}
    >
      {displayLabel} {value ? '✓' : ''}
    </button>
  );
}
